<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <div class="item-son" v-if="searchShow">
            <el-input
                clearable
                v-model="listParams.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                style="width: 180px"
                @keyup.enter.native="SearchServiceList"
            ></el-input>
            <el-select
                v-model="listParams.channelAccountId"
                clearable
                filterable
                placeholder="渠道账号"
                style="margin: 0 10px"
            >
              <el-option
                  v-for="item in channelAddList"
                  :key="item.channelAccountId"
                  :label="`${item.channelTypeName}-${item.name}-${item.account}`"
                  :value="item.channelAccountId"
              ></el-option>
            </el-select>
            <el-select
                v-model="listParams.expenseStatus"
                clearable
                placeholder="请选择状态"
                style="width: 180px"
            >
              <el-option label="正常" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </div>
          <div class="item-son" v-if="searchShow">
            <el-button type="primary" @click="queryTableData"
            >查询 <i class="el-icon-search"></i>
            </el-button>
          </div>
          <div class="item-son" v-if="addShow">
            <el-button type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="public-table-data">
      <el-table
          ref="multipleTable"
          size="medium"
          :data="tableData"
          border
          style="width: 100%;cursor: pointer"
          row-key="menuId"
          v-loading="loading"
      >
        <el-table-column align="center" fixed label="序号" type="index" width="100">
          <template slot-scope="scope">
                <span @click="handleClick('edit', scope.row)">{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="channelTypeName" label="渠道" width="160" align="center">
          <template slot-scope="scope" >
            <div  @click="handleClick('edit', scope.row)">{{scope.row.channelTypeName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="account" label="账号" width="200" align="center">
          <template slot-scope="scope" >
            <div  @click="handleClick('edit', scope.row)">{{scope.row.account }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="标识" width="160" align="center">
          <template slot-scope="scope" >
            <div  @click="handleClick('edit', scope.row)">{{scope.row.code }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="subTime" label="消费日期" width="200" align="center">
          <template slot-scope="scope" >
            <div  @click="handleClick('edit', scope.row)">{{scope.row.subTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="subName" label="填写人" width="120" align="center">
          <template slot-scope="scope" >
            <div  @click="handleClick('edit', scope.row)">{{scope.row.subName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="ctime" label="填写时间" width="180" align="center">
          <template slot-scope="scope" >
            <div  @click="handleClick('edit', scope.row)">{{scope.row.ctime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag @click="handleClick('edit', scope.row)" size="mini">{{scope.row.expenseStatusName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="confirmTime" label="确认时间" width="180" align="center">
          <template slot-scope="scope" >
            <div  @click="handleClick('edit', scope.row)">{{scope.row.confirmTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" min-width="150">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleClick('edit', scope.row)"
                type="warning"
                v-if="scope.row.btn.detail"
                plain
            >详情
            </el-button
            >
            <el-button
                v-if="scope.row.btn.delete"
                size="mini"
                @click="handleDelete(scope.row)"
                type="primary"
                plain
            >删除
            </el-button
            >
            <el-button
                v-if="scope.row.btn.close"
                size="mini"
                @click="handleRevoke(scope.row)"
                type="primary"
                plain
            >撤销
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="roleRight_pagenation" style="padding: 30px 0 20px;text-align: center">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNo"
          :page-sizes="[PAGE_SIZE, 15, 20, 25]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.count"
      >
      </el-pagination>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="渠道消费"
        :visible.sync="dialogVisible"
        width="970px"
        :close-on-click-modal="false"
        class="public-dialog "
    >
      <div class="public-dialog-form xq_checkColor">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="110px"
        >
          <el-form-item label=" 渠道账户：" prop="channelAccountId">
            <el-select
                v-model="params.channelAccountId"
                clearable
                :disabled="clickType=='edit'"
                placeholder="请选择渠道账户"
                style="width: 220px"
            >
              <el-option :key="index" v-for="(item,index) in channelAddList"
                         :label="`${item.channelTypeName}-${item.name}-${item.account}`"
                         :value="item.channelAccountId"></el-option>
            </el-select>
<!--            :label="`${item.channelTypeName}-${item.name}-${item.account}`"-->
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-form-item label="消费日期：" prop="expenseTime">
                <el-date-picker
                    :readonly="clickType=='edit'"
                    v-model="params.expenseTime"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="position: relative">
              <span class="clear_icon_items">*</span>
              <el-form-item label="消费：">
                <div style="display: flex;justify-content: space-between">
                  <div class="tab_box_info">
                    <div class="tab_head" style="border-top: 1px solid rgba(0,0,0,0.1);">
                      <div>时间</div>
                      <div>消费账户币</div>
                      <div>返点（%）</div>
                      <div>消费金额</div>
                      <div>操作</div>
                    </div>
                    <div class="tab_head" v-for="(item,index) in consumptionList" :key="index">
                      <div>{{ item.expenseHour }}</div>
                      <div>
                        <el-input @input="changInput($event,index,item)" :readonly="clickType=='edit'" type="number" class="input_box" v-model="item.money1"></el-input>
                      </div>
                      <div>
                        <el-input @input="changRedInput($event,index,item)" :readonly="clickType=='edit'" type="number" class="input_box" v-model="item.rate"></el-input>
                      </div>
                      <div>
                        <el-input :readonly="clickType=='edit'" type="number" class="input_box" v-model="item.money2"></el-input>
                      </div>
                      <div><el-tag @click="changSaveInput(item)" size="small">同步</el-tag></div>
                    </div>
                  </div>
                  <div class="tab_box_info">
                    <div class="tab_head" style="border-top: 1px solid rgba(0,0,0,0.1);">
                      <div>时间</div>
                      <div>消费账户币</div>
                      <div>返点（%）</div>
                      <div>消费金额</div>
                      <div>操作</div>
                    </div>
                    <div class="tab_head" v-for="(item,index) in consumptionList1" :key="index">
                      <div>{{ item.expenseHour }}</div>
                      <div>
                        <el-input @input="changInput($event,index,item)" :readonly="clickType=='edit'" type="number" class="input_box" v-model="item.money1"></el-input>
                      </div>
                      <div>
                        <el-input @input="changRedInput($event,index,item)" :readonly="clickType=='edit'" type="number" class="input_box" v-model="item.rate"></el-input>
                      </div>
                      <div>
                        <el-input :readonly="clickType=='edit'" type="number" class="input_box" v-model="item.money2"></el-input>
                      </div>
                      <div><el-tag @click="changSaveInput(item)" size="small">同步</el-tag></div>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer" v-if="clickType!='edit'">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {PAGE_SIZE, FILE_ROOT, JOB_STATUS} from "@config";
import {ossUpload} from "@utils/filters/upload";
import {isEmpty} from "../../utils/tools";
import OperationConfirmation from "../../components/OperationConfirmation";

export default {
  components: {OperationConfirmation},
  data() {
    return {
      PAGE_SIZE,
      isEmpty,
      tableData: [],
      channelList: [],
      listParams: {},
      params: {},
      dialogVisible: false,
      total: 0,
      loading: false,
      clickType: "",
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      rules: {
        channelAccountId: [
          {required: true, message: "请选择类型", trigger: "change"},
        ],
        expenseTime: [
          {required: true, message: "请选择日期", trigger: "change"},
        ],
      },

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,

      consumptionList: [
        {
          expenseHour: 0,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 1,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 2,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 3,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 4,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 5,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 6,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 7,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 8,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 9,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 10,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 11,
          money1: 0,
          money2: 0,
          rate: 0
        },
      ],

      consumptionList1: [
        {
          expenseHour: 12,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 13,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 14,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 15,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 16,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 17,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 18,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 19,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 20,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 21,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 22,
          money1: 0,
          money2: 0,
          rate: 0
        },
        {
          expenseHour: 23,
          money1: 0,
          money2: 0,
          rate: 0
        },
      ],
      channelAddList:[],
      userInfo:{}
    };
  },
  mounted() {
    // this.getChannelList()
    this.queryTableData();
    this.getPermissionButtonList()
    this.maneyInfd()
  },
  computed: {},
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.consumptionList =  [
          {
            expenseHour: 0,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 1,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 2,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 3,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 4,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 5,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 6,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 7,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 8,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 9,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 10,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 11,
            money1: 0,
            money2: 0,
            rate: 0
          },
        ]
        this.consumptionList1 =  [
          {
            expenseHour: 12,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 13,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 14,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 15,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 16,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 17,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 18,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 19,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 20,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 21,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 22,
            money1: 0,
            money2: 0,
            rate: 0
          },
          {
            expenseHour: 23,
            money1: 0,
            money2: 0,
            rate: 0
          },
        ]
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'finance:consumption:query') {
            this.searchShow = true
          }
          if (item.code == 'finance:consumption:add') {
            this.addShow = true
          }
        })
      }
    },
    /**
     * 获取渠道 账号 类型
     */
    // async getChannelList() {
    //   const {data: orgData} = await this.$get(`/channel/account/list?paging=false`);
    //   this.channelList = orgData.data;
    // },
    async maneyInfd() {
      this.loading = true;
      const {data: resData} = await this.$get("/console/info2");
      this.loading = false;
      if (resData.result != 200) return;
      this.userInfo = resData.data.info;
      this.getAddChannelList()
    },
    async getAddChannelList() {
      const {data: orgData} = await this.$get(`/advertiser/channel/list?permissionType=tf&advertiserId=` + this.userInfo.advertiserId);
      let arr = []
      if(orgData.data){
        orgData.data.map(item=>{
           if(item.advertiserChannels.length){
             item.advertiserChannels.map(items=>{
               items.channelTypeName = item.channelTypeName
               arr.push(items)
             })
           }
        })
      }
      this.channelAddList = arr;
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;
      const {data: resData} = await this.$get("/channel/expense/list", {
        params: {
          ...this.listParams,
          ...this.page,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.page.count = resData.page.count;
    },

    changInput(e,index,item){
      let num = (e / (1 + (item.rate/100) ))
      item.money2 = num.toFixed(2)
    },

    changRedInput(e,index,item){
      if(item.money1 ){
        let num = (item.money1 / (1 + (e / 100) ))
        item.money2 = num.toFixed(2)
      }
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "edit") {
        //编辑
        const {data: resData} = await this.$get(
            `/channel/expense/info/${row.channelExpenseId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.params = resData.data;
        this.consumptionList = resData.data.items.slice(0,12)
        this.consumptionList1 = resData.data.items.slice(12)
        this.dialogVisible = true;
      }
      if (type == "add") {
        this.params = {};
        this.dialogVisible = true;
      }
    },

    changSaveInput(e){
      this.consumptionList.map(item=>{
        item.rate = e.rate
        if(item.money1){
          let num = (item.money1 / (1 + (item.rate / 100) ))
          item.money2 = num.toFixed(2)
        }

      })
      this.consumptionList1.map(item=>{
        item.rate = e.rate
        if(item.money1){
          let num = (item.money1 / (1 + (item.rate / 100) ))
          item.money2 = num.toFixed(2)
        }
      })
    },

    //查询
    SearchServiceList() {
      this.page.pageNo = 1
      delete this.page['count']
      this.getserviceList()
    },
    /**
     * 编辑/增加
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        let arr = this.consumptionList.concat(this.consumptionList1)
        arr.map(item=>{
          item.money2 = Number(item.money2)
          item.money1 = Number(item.money1)
          item.rate = Number(item.rate)
          if(item.money1===''){
            this.$message.error('时间段为'+item.expenseHour+'消费账户币不能为空')
            return
          }
          if(item.rate===''){
            this.$message.error('时间段为'+item.expenseHour+'返点不能为空')
            return
          }
          if(item.rate===''){
            this.$message.error('时间段为'+item.expenseHour+'消费金额不能为空')
            return
          }
        })
        this.params.items = arr
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
            const {data: resData} = await this.$post(
                "/channel/expense/sub",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.queryTableData();
            this.dialogVisible = false;
            this.$message.success("添加成功!");
            this.params = {};
        });
      });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/channel/expense/info/${row.channelExpenseId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.queryTableData();
      });
    },
    /**
     * 撤销
     */
    handleRevoke(row) {
      let obj = {
        channelOrderId: row.channelOrderId,
        closeRemark: '撤销工单'
      }
      this.$confirm("此操作将撤销当前工单, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$put(
            `/channel/expense/close`, obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getserviceList();
        this.$message.success("撤销成功!");
      });
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>
<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: 46px;
  top: 12px;
}
.icon-width {
  width: 20px;
  height: 20px;
  display: inline-block;
}

.screenshot {
  position: relative;
}

.xq_checkColor {
  ::v-deep .el-color-picker__trigger {
    width: 60px !important;
    height: 60px !important;
  }
}

.bank_box {
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 40px;
    height: 40px;
    object-fit: contain;
    margin-right: 10px;
  }
}

.tab_box_info {
  width: 400px;
  cursor: pointer;
  .tab_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    height: 30px;
    box-sizing: border-box;

    > div {
      text-align: center;
      box-sizing: border-box;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      color: rgba(51, 51, 51, 1);
      height: 100%;
      line-height: 30px;

      .input_box {
        height: 100%;
        width: 85%;
        margin: 0 auto;
        border: 0;

        .el-input__inner {
          width: 100% !important;
          height: 100% !important;
          border: 0 !important;
        }
      }
    }

    > div:nth-child(1),> div:nth-child(5)  {
      width: 60px;
    }

    > div:nth-child(3) {
      width: 80px;
    }

    > div:nth-child(2), > div:nth-child(4) {
      width: 100px;
    }
  }
}

</style>

<style lang="scss">
.input_box {
  height: 100%;
  width: 85%;
  margin: 0 auto;
  border: 0;

  .el-input__inner {
    width: 100% !important;
    height: 100% !important;
    border: 0 !important;
    text-align: center;
  }
}
</style>